import React, { useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
const GT_LOGO_URL = 'https://www.gtlaw.com/-/media/images/global-sitewide-images/logo.svg?rev=d07323a607914ace919ae5feec7c119b&hash=59AF347B3177907F6747626218361229';
export const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return <nav className="bg-white shadow-sm sticky top-0 z-50 border-b border-[#D4C88A]/30" data-id="element-271">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-272">
        <div className="flex justify-between h-20" data-id="element-273">
          <div className="flex items-center" data-id="element-274">
            <img src={GT_LOGO_URL} alt="Greenberg Traurig" className="h-10" data-id="element-275" />
          </div>
          <div className="hidden md:flex items-center space-x-8" data-id="element-276">
            <a href="#about" className="text-[#3D3A25] hover:text-[#C4A44A] transition-colors text-sm font-semibold uppercase tracking-wide" data-id="element-277">
              About gTLDs
            </a>
            <a href="#process" className="text-[#3D3A25] hover:text-[#C4A44A] transition-colors text-sm font-semibold uppercase tracking-wide" data-id="element-278">
              Process
            </a>
            <a href="#benefits" className="text-[#3D3A25] hover:text-[#C4A44A] transition-colors text-sm font-semibold uppercase tracking-wide" data-id="element-279">
              Benefits
            </a>
            <a href="#faq" className="text-[#3D3A25] hover:text-[#C4A44A] transition-colors text-sm font-semibold uppercase tracking-wide" data-id="element-280">
              FAQ
            </a>
            <a href="#team" className="text-[#3D3A25] hover:text-[#C4A44A] transition-colors text-sm font-semibold uppercase tracking-wide" data-id="element-281">
              Meet the Team
            </a>
            <a href="#contact" className="bg-[#C4A44A] text-white px-5 py-2.5 rounded-sm hover:bg-[#B39540] transition-colors text-sm font-bold uppercase tracking-wider shadow-sm" data-id="element-282">
              Contact Us
            </a>
          </div>
          <div className="md:hidden flex items-center" data-id="element-283">
            <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="text-[#3D3A25] hover:text-[#C4A44A] focus:outline-none" data-id="element-284">
              {isMenuOpen ? <XIcon className="h-6 w-6" data-id="element-285" /> : <MenuIcon className="h-6 w-6" data-id="element-286" />}
            </button>
          </div>
        </div>
      </div>
      {isMenuOpen && <div className="md:hidden bg-white shadow-lg border-t border-[#D4C88A]/30" data-id="element-287">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3" data-id="element-288">
            <a href="#about" className="block px-3 py-3 text-[#3D3A25] hover:text-[#C4A44A] hover:bg-[#F7F5EE] uppercase text-sm font-semibold tracking-wide" onClick={() => setIsMenuOpen(false)} data-id="element-289">
              About gTLDs
            </a>
            <a href="#process" className="block px-3 py-3 text-[#3D3A25] hover:text-[#C4A44A] hover:bg-[#F7F5EE] uppercase text-sm font-semibold tracking-wide" onClick={() => setIsMenuOpen(false)} data-id="element-290">
              Process
            </a>
            <a href="#benefits" className="block px-3 py-3 text-[#3D3A25] hover:text-[#C4A44A] hover:bg-[#F7F5EE] uppercase text-sm font-semibold tracking-wide" onClick={() => setIsMenuOpen(false)} data-id="element-291">
              Benefits
            </a>
            <a href="#faq" className="block px-3 py-3 text-[#3D3A25] hover:text-[#C4A44A] hover:bg-[#F7F5EE] uppercase text-sm font-semibold tracking-wide" onClick={() => setIsMenuOpen(false)} data-id="element-292">
              FAQ
            </a>
            <a href="#team" className="block px-3 py-3 text-[#3D3A25] hover:text-[#C4A44A] hover:bg-[#F7F5EE] uppercase text-sm font-semibold tracking-wide" onClick={() => setIsMenuOpen(false)} data-id="element-293">
              Meet the Team
            </a>
            <a href="#contact" className="block px-3 py-3 bg-[#C4A44A] text-white uppercase text-sm font-bold tracking-wider mt-2" onClick={() => setIsMenuOpen(false)} data-id="element-294">
              Contact Us
            </a>
          </div>
        </div>}
    </nav>;
};